import { Controller } from 'stimulus';
import Swiper from 'swiper/bundle';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
class _class extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, { ...this.defaultOptions,
      ...this.optionsValue
    });
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }

  get defaultOptions() {
    return {};
  }

}

_defineProperty(_class, "values", {
  options: Object
});

export default _class;
//# sourceMappingURL=index.js.map
